import { render, staticRenderFns } from "./PromotionDappStepReward.vue?vue&type=template&id=20b60796&scoped=true&"
import script from "./PromotionDappStepReward.vue?vue&type=script&lang=js&"
export * from "./PromotionDappStepReward.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappStepReward.vue?vue&type=style&index=0&id=20b60796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b60796",
  null
  
)

export default component.exports